import { useContext } from 'react'

import { ChatRefsContext } from './ChatRefsContext'

export const useChatRefs = () => {
  const context = useContext(ChatRefsContext)
  if (!context) {
    throw new Error('useChatRefs must be used within a ChatRefsProvider')
  }
  return context
}
